module.exports = __webpack_public_path__ + "media/images/icons/icn_021-03dd387428c0505eafa3c4dcf22bb84b.svg";